<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="5">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>责编：</label>
            <a-input
              placeholder="请输入"
              v-model="queryEditor"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <template v-if="record.auditStatus == 7">
              <a href="javascript:void(0);" @click="() => cancelAudit(record)">
                取消审核
              </a>
            </template>
            <a-divider type="vertical" v-if="record.auditStatus == 7" />
            <a href="javascript:void(0);" @click="() => auditedOpinion(record)">
              审稿意见
            </a>
            <a-divider type="vertical" v-if="record.auditStatus == 7" />
            <template v-if="record.auditStatus == 7">
              <a href="javascript:void(0);" @click="() => toBack(record)">
                撤回
              </a>
            </template>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <template slot="auditStatus" slot-scope="auditStatus, record">
            <template v-if="record.result == 0">
              <span v-if="auditStatus == 4">已一审</span>
              <span v-if="auditStatus == 5">已二审</span>
              <span v-if="auditStatus == 6">已三审</span>
              <span v-if="auditStatus == 7">待专家审核</span>
              <span v-if="auditStatus == 8">专家审核完成</span>
              <span v-if="auditStatus == 9">已一校</span>
              <span v-if="auditStatus == 10">已二校</span>
              <span v-if="auditStatus == 11">已三校</span>
            </template>
            <template v-else>
              <span v-if="record.result == 33">需退改</span>
              <span v-if="record.result == 44">需退稿</span>
            </template>
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">
              {{ record.code }}
            </label>
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">
                  {{ record.cnTitle }}
                </label>
              </div>
            </a-tooltip>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
      </a-select>
    </div>

    <AuditOpinions ref="auditOpinions" :infoData="manuscript" />
    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>

<script>
//稿件信息
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "code",
    width: 130,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "学科",
    dataIndex: "discipline",
  },
  {
    title: "作者",
    width: 90,
    dataIndex: "authorName",
  },
  {
    title: "所在单位",
    dataIndex: "companyName",
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "栏目",
    dataIndex: "columnInfo",
  },
  {
    title: "状态",
    width: 110,
    dataIndex: "auditStatus",
    scopedSlots: { customRender: "auditStatus" },
  },
  {
    title: "稿件字数",
    width: 90,
    dataIndex: "wordCount",
  },
  {
    title: "责任编辑",
    width: 90,
    dataIndex: "editor",
  },
  {
    title: "操作",
    width: 220,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
import AuditOpinions from "../../../commomon/AuditOpinions.vue";
export default {
  name: "auditing",
  components: {
    ManuscriptInfo,
    AuditOpinions,
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      manuscript: {},
      data: [],
      columns,
      selectedRowKeys: [],
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      queryEditor: "",
      sort: "1",
      sortField: "code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
      roleCode: "",
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.roleCode = sessionStorage.getItem("roleCode");
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    cancelAudit(record) {
      let _this = this;
      _this.$confirm({
        title: "确定要取消审核吗?",
        onOk() {
          var statusList = [record.auditStatus - 1];
          _this.axios
            .post("/manuscripts/changeAuditStatus", {
              code: record.code,
              statusList: statusList.join(","),
              type: 2,
            })
            .then((res) => {
              if (res.data.code == "OK") {
                _this.utils.messageInfo(_this, "success", "操作成功");
                _this.query();
              } else {
                _this.utils.messageInfo(_this, "error", "操作失败！");
              }
            });
        },
        onCancel() {},
      });
    },
    toBack(record) {
      let _this = this;
      _this.$confirm({
        title: "确定要撤回稿件吗?",
        onOk() {
          var statusList = [record.auditStatus - 2];
          _this.axios
            .post("/manuscripts/changeAuditStatus", {
              code: record.code,
              statusList: statusList.join(","),
              type: 2,
            })
            .then((res) => {
              if (res.data.code == "OK") {
                _this.utils.messageInfo(_this, "success", "操作成功");
                _this.query();
              } else {
                _this.utils.messageInfo(_this, "error", "操作失败！");
              }
            });
        },
        onCancel() {},
      });
    },
    auditedOpinion(record) {
      this.manuscript = record;
      this.$refs.auditOpinions.show();
    },
    manuscriptsInfo(record) {
      this.manuscript = record;
      this.$refs.manuscriptInfo.show();
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=12"
        );
      } else if (this.operateCode == 2) {
        //批量下载
      }
    },
    query() {
      this.axios
        .get("/manuscripts/chiefAudited", {
          params: {
            code: this.queryCode,
            cnTitle: this.queryCnTitle,
            editor: this.queryEditor,
            authorName: this.queryAuthorName,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
</style>